import { Component, OnInit, Inject, ViewChild, ElementRef     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { User                          } from 'src/app/beans/login/user/user.bean';
import { MessageVisibilityFilter       } from 'src/app/beans/message/message.visibility.filter';
import { MessageDetail                 } from 'src/app/beans/message/message.detail.bean';
import { DatePipe                      } from '@angular/common';
import { Site } from 'src/app/beans/site/site.bean';
import { Service } from 'src/app/beans/service/service.bean';
import { ServiceSelect } from 'src/app/components/select/service/service-select/service.select';
import { Result } from 'src/app/beans/result/result.bean';

@Component
({
    selector: 'message-dialog',
    templateUrl: './message.dialog.html',
    styleUrls: ['./message.dialog.scss'],
})

export class MessageDialog implements OnInit 
{

  today: Date = new Date()
  
  serviceManager: ServiceSelect
  @ViewChild('serviceManager') set _serviceManager(serviceManager: ServiceSelect){
    console.log( serviceManager );
    this.serviceManager = serviceManager
    this.selectService( serviceManager ) 
  }

  selectService(serviceManager: ServiceSelect){
    if( !serviceManager ) return 

    if(!this._message.msgServiceId || this._message.msgServiceId == 0) return 

    console.log( this._message.msgServiceId );
    
    serviceManager.selectById ( this._message.msgServiceId ) 

  }


  visibilities: MessageVisibilityFilter[] =
    [
      {
        title: "dialog.message.generic.organization",
        level: "organization",
        value: null
      },
      {
        title: "dialog.message.generic.site",
        level: "site",
        value: null
      },
      {
        title: "dialog.message.generic.service",
        level: "service",
        value: null
      },
    ]

  public site : Site
  public _message: MessageDetail

  public selectedVisibility: any

  private orgVisibility: number = null
  private sitVisibility: number = null
  private serVisibility: number = null

  service: Service

  constructor
    (
      private dialogRef: MatDialogRef<MessageDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,

      private _handler : HandlerManager,
      private _loader  : LoadingManager,
      private _session : SessionManager,
      private _datepipe: DatePipe
  ) { }

  ngOnInit(): void 
  {
    //Set message object
    this._message = this.data.message

    //If message is null, set object data to null
    if (!this._message) 
    {
      this._message =
      {
        id               : null,
        text             : null,
        dateBegin        : null,
        dateEnd          : null,
        msgOrganizationId: null,
        msgSiteId        : null,
        msgServiceId     : null,
        msgServiceName   : null,
        tkTarg           : null,
        dsTarg           : null,
        apTarg           : null,
        coTarg           : null,
      }
    }
    else
    {
      this.visibilities[2].value = this._message.msgServiceId  
    }

    this.visibilities[0].value = this.data.organizationId
    this.visibilities[1].value = this.data.site.id

    this.setVisibility()

    //Set siteId
    this.site = this.data.site

    if(!this._message.dateBegin) this._message.dateBegin = new Date().toString();

    this.selectService( this.serviceManager )

  }

  setService( service: Service )
  {    
    console.log( service );
    
    this.service = service
    this._message.msgServiceId = service.id
    this.serVisibility = this.service.id
  }

  setVisibility()
  {
    if( this._message.msgOrganizationId && this._message.msgOrganizationId != 0 ) this.selectedVisibility = "organization"
    if( this._message.msgSiteId         && this._message.msgSiteId         != 0 ) this.selectedVisibility = "site"
    if( this._message.msgServiceId      && this._message.msgServiceId      != 0 ) this.selectedVisibility = "service" 
  }

  //---------------------------------------------------------------------------------------------------

  cancel() {
    this.operationDeclined()
  }

  async create() {

    this.defOperation()
    let response = await this.changeValue( "create" );
    this.operationAccepted(response)
  }

  async update() {

    this.defOperation()
    let response = await this.changeValue( "update" )
    this.operationAccepted(response)
  }

  //---------------------------------------------------------------------------------------------------

  defOperation()
  {
    this.trasformCheckboxValue()
    this.transformDate()
    this.getCurrentVisibility()
  }

  trasformCheckboxValue()
  {
    this._message.tkTarg = this._message.tkTarg ? 1 : 0
    this._message.dsTarg = this._message.dsTarg ? 1 : 0
    this._message.apTarg = this._message.apTarg ? 1 : 0
    this._message.coTarg = this._message.coTarg ? 1 : 0
  }

  transformDate()
  {
    const pipe = new DatePipe('en-US');
    if (this._message.dateBegin ) this._message.dateBegin = pipe.transform(this._message.dateBegin, 'yyyy-MM-dd');
    if (this._message.dateEnd   ) this._message.dateEnd   = pipe.transform(this._message.dateEnd  , 'yyyy-MM-dd');
  }

  getCurrentVisibility()
  {
    switch (this.selectedVisibility) 
    {
      case "organization":
        this.orgVisibility = this.visibilities[0].value
        this.sitVisibility = null;
        this.serVisibility = null
      break;

      case "site":
        this.orgVisibility = null
        this.sitVisibility = this.visibilities[1].value
        this.serVisibility = null

      break;

      case "service":
        this.orgVisibility = null
        this.sitVisibility = null
        this.serVisibility = this.serviceManager.getSelectedValue().id
      break;
    }
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue(operation: string) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return

    this._loader.start()

    let message = this._message

    let data: MessageDetail =
    {
      id               : message.id,
      text             : message.text,
      dateBegin        : message.dateBegin,
      dateEnd          : message.dateEnd,
      msgOrganizationId: this.orgVisibility,
      msgSiteId        : this.sitVisibility,
      msgServiceId     : this.serVisibility,
      msgServiceName   : null,
      tkTarg           : message.tkTarg,
      dsTarg           : message.dsTarg,
      apTarg           : message.apTarg,
      coTarg           : message.coTarg,
    };

    let response = null
    if (operation && operation === "create") response = await this._handler.message().create((user as User).token, this.site.id, data)
    if (operation && operation === "update") response = await this._handler.message().update((user as User).token, this.site.id, message.id, data)

    this._loader.stop()

    return response
  }

  //---------------------------------------------------------------------------------------------------

  operationAccepted(response: any) 
  {
    if(Result.isKind(response) && response.result == 1)
    {
      this.dialogRef.close
      (
        {
          code: DialogsReturnCode.MESSAGE_OPERATION_ACCEPTED
        }
      )
    }
  }

  operationDeclined() 
  {
    this.dialogRef.close
      (
        {
          code: DialogsReturnCode.OPERATION_DECLINED
        }
      )
  }

  //---------------------------------------------------------------------------------------------------

  controlDate()
  {
    //Control if data range not compred today
    let currentDate = this._datepipe.transform(new Date(), 'yyyy-MM-dd')

    this.transformDate()
    
    if( !this._message.dateBegin || !this._message.dateEnd ) return false

    return currentDate > this._message.dateBegin && currentDate < this._message.dateEnd ? true : false
  }

  controlTarget()
  {
    return !this._message.tkTarg && !this._message.dsTarg && !this._message.coTarg && !this._message.apTarg ? true : false
  }

  autoSelectFirst(){
    return this._message?.msgServiceId ? false : true;
  }
}
